const quizSections = document.querySelectorAll('.scent-quiz');
quizSections.forEach(initScentQuiz);

function initScentQuiz(section) {
  const app = section.querySelector('.scent-quiz__app');
  if (!app) return;

  const questionWrap = section.querySelector('[data-quiz-question]');
  const answersWrap = section.querySelector('[data-quiz-answers]');
  const nextBtn = section.querySelector('[data-quiz-next]');
  const backBtn = section.querySelector('[data-quiz-back]');
  const restartBtn = section.querySelector('[data-quiz-restart]');
  const progressFill = section.querySelector('[data-quiz-progress]');
  const progressText = section.querySelector('[data-quiz-progress-text]');
  const resultsWrap = section.querySelector('[data-quiz-results]');
  const questionScreen = section.querySelector('[data-quiz-screen="questions"]');
  const resultsScreen = section.querySelector('[data-quiz-screen="results"]');

  const resultsCount = parseInt(app.dataset.resultsCount || '3', 10);
  const primaryCtaLabel = app.dataset.primaryCtaLabel || '';
  const primaryCtaUrl = app.dataset.primaryCtaUrl || '';
  const secondaryCtaLabel = app.dataset.secondaryCtaLabel || '';
  const secondaryCtaUrl = app.dataset.secondaryCtaUrl || '';

  const questionsJsonEl = section.querySelector('[data-quiz-questions]');
  if (!questionsJsonEl) return;

  let questions = [];
  try {
    questions = JSON.parse(questionsJsonEl.textContent);
  } catch (error) {
    console.error('Failed to parse scent quiz questions JSON', error);
    return;
  }

  questions = questions.filter((question) => {
    return question && question.key && question.title && Array.isArray(question.answers) && question.answers.length > 0;
  });

  if (!questions.length) return;

  const products = Array.from(section.querySelectorAll('[data-product]')).map((el) => ({
    handle: el.dataset.handle || '',
    title: el.dataset.title || '',
    url: el.dataset.url || '#',
    image: el.dataset.image || '',
    price: el.dataset.price || '',
    vendor: el.dataset.vendor || '',
    scent_family: normaliseList(el.dataset.scentFamily),
    mood: normaliseList(el.dataset.mood),
    occasion: normaliseList(el.dataset.occasion),
    intensity: normaliseList(el.dataset.intensity),
    style: normaliseList(el.dataset.style),
    starter: normaliseScalar(el.dataset.starter),
    top: el.dataset.top || '',
    heart: el.dataset.heart || '',
    base: el.dataset.base || '',
    curator: el.dataset.curator || ''
  }));

  let currentIndex = 0;
  const state = {};

  renderQuestion();
  bindEvents();

  function bindEvents() {
    nextBtn.addEventListener('click', () => {
      const question = questions[currentIndex];
      const selections = state[question.key] || [];

      if (!selections.length) return;

      if (currentIndex < questions.length - 1) {
        currentIndex += 1;
        renderQuestion();
      } else {
        renderResults();
      }
    });

    backBtn.addEventListener('click', () => {
      if (currentIndex === 0) return;
      currentIndex -= 1;
      renderQuestion();
    });

    if (restartBtn) {
      restartBtn.addEventListener('click', () => {
        Object.keys(state).forEach((key) => delete state[key]);
        currentIndex = 0;
        resultsScreen.hidden = true;
        questionScreen.hidden = false;
        renderQuestion();
      });
    }
  }

  function renderQuestion() {
    const question = questions[currentIndex];
    const selectionMode = question.selection_mode === 'single' ? 'single' : 'multi';
    const maxSelections = parseInt(question.max_selections || '1', 10);
    const selectedValues = state[question.key] || [];

    let meta = '';
    if (selectionMode === 'multi') {
      meta = maxSelections > 1 ? `Select up to ${maxSelections}` : 'Select 1';
    } else {
      meta = 'Select 1';
    }

    questionWrap.innerHTML = `
      <h3>${escapeHtml(question.title)}</h3>
      <p class="scent-quiz__question-meta">${escapeHtml(meta)}</p>
    `;

    answersWrap.innerHTML = '';

    question.answers.forEach((answer) => {
      const isSelected = selectedValues.includes(answer.value);
      const button = document.createElement('button');

      button.type = 'button';
      button.className = 'scent-quiz__answer';
      button.dataset.answerValue = answer.value;

      if (isSelected) {
        button.classList.add('is-selected');
      }

      button.innerHTML = `
        <span class="scent-quiz__answer-title">${escapeHtml(answer.label)}</span>
        ${answer.copy ? `<span class="scent-quiz__answer-copy">${escapeHtml(answer.copy)}</span>` : ''}
      `;

      button.addEventListener('click', () => {
        const currentSelections = state[question.key] ? [...state[question.key]] : [];

        if (selectionMode === 'single') {
          state[question.key] = [answer.value];
        } else {
          const alreadySelected = currentSelections.includes(answer.value);

          if (alreadySelected) {
            state[question.key] = currentSelections.filter((value) => value !== answer.value);
          } else {
            if (currentSelections.length < maxSelections) {
              state[question.key] = [...currentSelections, answer.value];
            } else {
              state[question.key] = [...currentSelections.slice(1), answer.value];
            }
          }
        }

        renderQuestion();
      });

      answersWrap.appendChild(button);
    });

    nextBtn.disabled = !selectedValues.length;
    nextBtn.textContent = currentIndex === questions.length - 1 ? 'See results' : 'Next';
    backBtn.hidden = currentIndex === 0;

    const progress = ((currentIndex + 1) / questions.length) * 100;
    progressFill.style.width = `${progress}%`;
    progressText.textContent = `Question ${currentIndex + 1} of ${questions.length}`;
  }

  function renderResults() {
    const scored = products
      .map((product) => ({
        ...product,
        score: scoreProduct(product, state, questions)
      }))
      .sort((a, b) => b.score - a.score)
      .filter((product) => product.score > 0);

    const topResults = scored.slice(0, resultsCount);
    resultsWrap.innerHTML = '';

    if (!topResults.length) {
      resultsWrap.innerHTML = `
        <div class="scent-quiz__empty">
          <p>No close matches came through this time. Try adjusting your answers or browse the full fragrance collection.</p>
        </div>
      `;
    } else {
      topResults.forEach((product) => {
        resultsWrap.appendChild(
          buildResultCard(product, primaryCtaLabel, primaryCtaUrl, secondaryCtaLabel, secondaryCtaUrl)
        );
      });
    }

    questionScreen.hidden = true;
    resultsScreen.hidden = false;
  }
}

function scoreProduct(product, state, questions) {
  let score = 0;

  questions.forEach((question) => {
    const key = question.key;
    const selectedValues = state[key] || [];
    if (!selectedValues.length) return;

    const productValue = product[key];

    if (!Array.isArray(productValue)) {
      if (selectedValues.includes(productValue)) {
        score += 4;
      }
      if (key === 'starter' && selectedValues.includes('maybe')) {
        score += 1;
      }
      return;
    }

    const matches = selectedValues.filter((value) => productValue.includes(value)).length;

    if (matches > 0) {
      score += 3;
      score += (matches - 1) * 2;
    }

    if (key === 'occasion' && selectedValues.length > 1 && productValue.includes('versatile')) {
      score += 1;
    }
  });

  return score;
}

function buildResultCard(product, primaryCtaLabel, primaryCtaUrl, secondaryCtaLabel, secondaryCtaUrl) {
  const card = document.createElement('article');
  card.className = 'scent-quiz__result-card';

  const imageHtml = product.image
    ? `
      <div class="scent-quiz__result-image">
        <a href="${product.url}">
          <img src="${product.image}" alt="${escapeHtml(product.title)}" loading="lazy">
        </a>
      </div>
    `
    : '';

  card.innerHTML = `
    ${imageHtml}
    <div class="scent-quiz__result-content">
      <p class="scent-quiz__result-vendor">${escapeHtml(product.vendor)}</p>
      <h4 class="scent-quiz__result-title">
        <a href="${product.url}">${escapeHtml(product.title)}</a>
      </h4>
      ${product.price ? `<p class="scent-quiz__result-price">${escapeHtml(product.price)}</p>` : ''}
      ${product.curator ? `<p class="scent-quiz__result-meta">${escapeHtml(product.curator)}</p>` : ''}
      ${
        product.top || product.heart || product.base
          ? `
            <p class="scent-quiz__result-notes">
              ${product.top ? `<strong>Top:</strong> ${escapeHtml(product.top)}<br>` : ''}
              ${product.heart ? `<strong>Heart:</strong> ${escapeHtml(product.heart)}<br>` : ''}
              ${product.base ? `<strong>Base:</strong> ${escapeHtml(product.base)}` : ''}
            </p>
          `
          : ''
      }
      <div class="scent-quiz__result-actions">
        <a class="button" href="${product.url}">View fragrance</a>
      </div>
    </div>
  `;

  return card;
}

function normaliseList(value) {
  if (!value) return [];
  return String(value)
    .split(/[|,]/)
    .map((item) => item.trim().toLowerCase())
    .filter(Boolean);
}

function normaliseScalar(value) {
  if (!value) return '';
  return String(value).trim().toLowerCase();
}

function escapeHtml(value) {
  return String(value)
    .replaceAll('&', '&amp;')
    .replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;')
    .replaceAll('"', '&quot;')
    .replaceAll("'", '&#039;');
}